import React from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

const LANGS = [
  { code: 'vi', labelKey: 'language.vietnamese', flag: '🇻🇳' },
  { code: 'en', labelKey: 'language.english', flag: '🇺🇸' }
];

export default function LanguageSwitcher() {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const current = i18n.language?.startsWith('en') ? 'en' : 'vi';
  const currentLang = LANGS.find(l => l.code === current) || LANGS[0];

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const changeLang = async (code) => {
    try {
      await i18n.changeLanguage(code);
      try { localStorage.setItem('lang', code); } catch (_) {}
      try { document.documentElement.setAttribute('lang', code); } catch (_) {}
    } finally {
      handleClose();
    }
  };

  return (
    <>
      <Tooltip title={t('language.select')} arrow>
        <IconButton
          aria-label={t('common.selectLanguageAria') || 'Languages button'}
          onClick={handleOpen}
          size="medium"
          className="lang-switcher-btn"
          sx={{
            ml: 0.5,
            width: 36,
            height: 36,
            borderRadius: '50%',
            color: 'inherit'
          }}
        >
          <span role="img" aria-hidden="true" style={{ fontSize: 18, lineHeight: 1 }}>{currentLang.flag}</span>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {LANGS.map(l => (
          <MenuItem key={l.code} selected={current === l.code} onClick={() => changeLang(l.code)}>
            <ListItemIcon style={{ minWidth: 28 }}>
              <span role="img" aria-label={l.code} style={{ fontSize: 18 }}>{l.flag}</span>
            </ListItemIcon>
            <ListItemText primary={t(l.labelKey)} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
